import { inject, Injectable } from "@angular/core";
import { ClinicsService } from "../../../api/services";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import {
  CreateClinicDto,
  FilterClinicDto,
  ResponseClinicDto,
  UpdateClinicDto,
} from "../../../api/models";

const TENANT = environment.tenant;

@Injectable({
  providedIn: "root",
})
export class ClinicsApiService {
  /** The clinics service */
  private readonly _clinicsService: ClinicsService = inject(ClinicsService);

  /**
   * Creates a new clinic
   * @param body the clinic data
   * @returns the created clinic
   */
  public create$(body: CreateClinicDto): Observable<ResponseClinicDto> {
    return this._clinicsService.clinicsControllerCreate({ body });
  }

  /**
   * Updates a clinic
   * @param id the clinic id
   * @param body the clinic data
   * @returns the updated clinic
   */
  public update$(
    id: string,
    body: UpdateClinicDto,
  ): Observable<ResponseClinicDto> {
    return this._clinicsService.clinicsControllerUpdate({
      tenant: TENANT,
      id,
      body,
    });
  }

  /**
   * Deletes a clinic
   * @param id the clinic id
   * @returns the deleted clinic
   */
  public delete$(id: string): Observable<void> {
    return this._clinicsService.clinicsControllerDelete({
      tenant: TENANT,
      id,
    });
  }

  /**
   * Retrieves a clinic
   * @param id the clinic id
   * @returns the clinic
   */
  public findOne$(id: string): Observable<ResponseClinicDto> {
    return this._clinicsService.clinicsControllerFindOne({
      tenant: TENANT,
      id,
    });
  }

  /**
   * Filters clinic
   * @param filterDto the filter data
   * @returns the filtered clinic
   */
  public filter$(
    filterDto: Partial<FilterClinicDto>,
  ): Observable<ResponseClinicDto[]> {
    const body: FilterClinicDto = {
      ...filterDto,
      tenant: TENANT,
    };

    return this._clinicsService.clinicsControllerFilter({
      body,
    });
  }
}
